import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { PRIMARY_CONTACT_KEY, normalizeEmail } from '../utils/contactEmailAliases';

/**
 * Aliases are written by the updateContactEmailAlias callable, which refuses an address another
 * account (or one of its portal users) already uses. Returns the fields written so the caller
 * can merge them into local state (ClientOverview/LeadOverview save the whole account later).
 * A conflict rejects with code 'functions/already-exists' and a message naming the other account.
 */
async function updateAlias(data) {
  const result = await httpsCallable(functions, 'updateContactEmailAlias')(data);
  return result.data;
}

export async function addContactEmailAlias(accountId, { email, contactKey, contactName }) {
  return updateAlias({
    accountId,
    action: 'add',
    email: normalizeEmail(email),
    contactKey: contactKey || PRIMARY_CONTACT_KEY,
    contactName: contactName || '',
  });
}

export async function removeContactEmailAlias(accountId, email) {
  return updateAlias({ accountId, action: 'remove', email: normalizeEmail(email) });
}
